export const colors = {
  primary: {
    main: '#129AA5',
    light: '#F4FDFE',
    dark: '#0E7E88',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#4CAF50',
    light: '#81C784',
    dark: '#388E3C',
  },
  background: {
    default: '#F4FDFE',
    paper: '#FFFFFF',
    footer: '#EBF9FA',
  },
  text: {
    primary: '#29323A',
    secondary: '#52595F',
    // Semantic text colors - much more flexible!
    heading: '#29323A', // All headings (h1, h2, h3, etc.)
    body: '#29323A', // Body text
    muted: '#52595F', // Less important text
    caption: '#52595F', // Small text, captions
    link: '#116FDD', // Hyperlinks (matches palette.blue[500])
    success: '#1E8528', // Success messages
    error: '#D93535', // Error messages
    warning: '#F59E0B', // Warning messages
  },
  action: {
    hover: '#EBF9FA',
    selected: '#F4FDFE',
  },
  grey: {
    100: '#FFFFFF',
    200: '#FAFAFA',
    300: '#ECEFF0',
    400: '#D6D8D9',
    500: '#6F7780',
    600: '#29323A',
    700: '#000B14',
  },
  teal: {
    100: '#F4FDFE',
    200: '#EBF9FA',
    300: '#AFEAF1',
    400: '#5EA9AF',
    500: '#0E7E88',
    600: '#0A5961',
    700: '#08454B',
  },
  blue: {
    100: '#EFF6FE',
    200: '#C0DBFA',
    300: '#91BFF6',
    400: '#3289EF',
    500: '#116FDD',
    600: '#0E57AD',
    700: '#0A3F7E',
  },
  green: {
    100: '#B4EEBA',
    200: '#8AE593',
    300: '#61DB6D',
    400: '#37D246',
    500: '#1E8528',
    600: '#155B1B',
    700: '#0B320F',
  },
  red: {
    100: '#FDF6F6',
    200: '#F6D0D0',
    300: '#EFA9A9',
    400: '#E88282',
    500: '#D93535',
    600: '#BD2323',
    700: '#961C1C',
  },
  orange: {
    100: '#FDF6E3',
    200: '#F9E4A6',
    300: '#F5D269',
    400: '#F1C02C',
    500: '#A78406',
    600: '#8A6F05',
    700: '#6D5A04',
  },
  purple: {
    100: '#F3EDFE',
    200: '#E6D7FD',
    300: '#D9C1FC',
    400: '#CCABFB',
    500: '#8247F4',
    600: '#6B3BC3',
    700: '#542F92',
  },
  yellow: {
    100: '#FFFBF0',
    200: '#FFF3D9',
    300: '#FFEBB3',
    400: '#FFE38C',
    500: '#F59E0B',
    600: '#C47E09',
    700: '#935E07',
  },
  cyan: {
    100: '#E0F7FA',
    200: '#B2EBF2',
    300: '#4DD0E1',
    400: '#26C6DA',
    500: '#20B2AA',
    600: '#1A8E88',
    700: '#146A66',
  },
  // Filter button specific colors
  filter: {
    statements: {
      active: '#0E7E88',
      activeBg: '#0E7E881F',
      inactive: '#4CAF50',
    },
    tax: {
      active: '#116FDD',
      activeBg: '#116FDD1F',
      inactive: '#4CAF50',
    },
    other: {
      active: '#DC6504',
      activeBg: '#DC65041F',
      inactive: '#4CAF50',
    },
  },
  // Semantic UI colors - much more flexible!
  ui: {
    border: {
      light: '#ECEFF0',
      medium: '#D6D8D9',
      dark: '#8A9299',
      iconButton: '#DFDFE2',
    },
    shadow: {
      light: 'rgba(0, 0, 0, 0.05)',
      medium: 'rgba(0, 0, 0, 0.1)',
      dark: 'rgba(0, 0, 0, 0.15)',
    },
    status: {
      success: '#1E8528',
      submitted: '#006F54',
      error: '#D93535',
      warning: '#F59E0B',
      info: '#0E7E88',
      inlineAction: '#B1040E',
    },
  },
} as const;
